import { createSelector } from 'reselect'
import getDeluxeSamplesCountCartSelect from 'modules/cart/redux/selectors/get-deluxe-samples-count'
import getMaxDeluxeSamplesCountCartSelect from 'modules/cart/redux/selectors/get-max-deluxe-samples-count'

const hasReachedMaxDeluxeSamplesCountCartSelect = createSelector(
  getDeluxeSamplesCountCartSelect(),
  getMaxDeluxeSamplesCountCartSelect,
  (
    deluxeSamplesCount,
    maxDeluxeSamplesCount
  ) => {
    return deluxeSamplesCount >= maxDeluxeSamplesCount
  }
)

export default hasReachedMaxDeluxeSamplesCountCartSelect
